import { getField, updateField } from 'vuex-map-fields'
import { APPOINTMENT } from '@/api'
import { uiHelper } from '@/utils'
import { AUTH_LOAD_PROFILE } from './auth.module'
import { AppointmentType } from '@/constants/enums'

/* Define Module Name */
// const MODULE_NAME = "appointment/";

/* Define Action Name */
const A_FETCH_UPCOMING_APPOINTMENTS = 'fetchUpcomingAppointments'
const A_FETCH_PAST_APPOINTMENTS = 'fetchPastAppointments'
const A_FETCH_APPOINTMENT_DETAIL = 'fetchAppointmentDetail'
const A_CHECK_STYLISTS = 'checkAvailableStylists'
const A_CHECK_APPOINTMENT_SLOT = 'checkAppointmentSlot'
const A_BOOK_APPOINTMENT = 'bookAppointment'
const A_CANCEL_APPOINTMENT = 'cancelAppointment'
const A_EDIT_APPOINTMENT = 'editAppointment'

/* Define Getter Name */
const G_APPOINTMENT_DETAIL = 'getAppointmentDetail'

/* Define Mutation Name */
const M_SET_UPCOMING_APPOINTMENT_LIST = 'setUpcomingAppointmentList'
const M_SET_PAST_APPOINTMENT_LIST = 'setPastAppointmentList'
const M_SET_AVAILABLE_DATES = 'setAvailableDates'
const M_SET_AVAILABLE_SERVICES = 'setAvailableServices'
const M_SET_AVAILABLE_TIMESLOTS = 'setAvailableTimeSlots'
const M_SET_AVAILABLE_STYLISTS = 'setAvailableStylists'
const M_SET_BOOKING_INFO = 'setBookingInfo'
const M_SET_APPOINTMENT_FORM = 'setAppointmentForm'
const M_RESET_APPOINTMENT_FORM = 'resetAppointmentForm'
const M_SET_APPOINTMENT_FORM_SALON = 'setAppointmentFormSalon'
const M_SET_APPOINTMENT_FORM_STYLIST = 'setAppointmentFormStylist'

/* Define Export Name */

const defaultAppointmentForm = {
  appointmentSalon: undefined,
  appointmentDate: uiHelper.getTodayDate(),
  appointmentTimeSlots: undefined,
  appointmentServices: undefined,
  appointmentStylist: undefined,
  appointmentRemarks: '',
  appointmentBookingId: undefined
}

const state = {
  upcomingAppointments: [],
  pastAppointments: [],
  availableDates: [],
  availableServices: [],
  availableTimeSlots: [],
  availableStylists: [],
  appointmentForm: {
    appointmentSalon: undefined,
    appointmentDate: uiHelper.getTodayDate(),
    appointmentTimeSlots: undefined,
    appointmentServices: undefined,
    appointmentStylist: undefined,
    appointmentRemarks: '',
    appointmentBookingId: undefined
  },
  bookingInfo: {}
}

//Getters
const getters = {
  getField,
  [G_APPOINTMENT_DETAIL]: (state) => (type, id) => {
    let arr
    if (type === 'upcoming') {
      arr = state.upcomingAppointments
    } else if (type === 'past') {
      arr = state.pastAppointments
    }
    let res = arr.filter((f) => f.booking_id === Number(id))[0]
    return res
  }
}

// Actions
const actions = {
  async [A_FETCH_UPCOMING_APPOINTMENTS]({ commit }, data) {
    await APPOINTMENT.fetchAppointments(data).then((response) => {
      commit(M_SET_UPCOMING_APPOINTMENT_LIST, response.booking)
    })
  },

  async [A_FETCH_PAST_APPOINTMENTS]({ commit }, data) {
    await APPOINTMENT.fetchAppointments(data).then((response) => {
      commit(M_SET_PAST_APPOINTMENT_LIST, response.booking)
    })
  },

  async [A_CHECK_STYLISTS]({ commit }, data) {
    return await APPOINTMENT.checkSlot(data).then((response) => {
      commit(M_SET_AVAILABLE_STYLISTS, response.stylist)
    })
  },

  async [A_CHECK_APPOINTMENT_SLOT]({ commit }, data) {
    return await APPOINTMENT.checkSlot(data).then((response) => {
      commit(M_SET_AVAILABLE_DATES, response.date)
      commit(M_SET_AVAILABLE_SERVICES, response.service)
      commit(M_SET_AVAILABLE_TIMESLOTS, response.time)
    })
  },

  async [A_BOOK_APPOINTMENT]({ commit, dispatch }, data) {
    return await APPOINTMENT.bookAppointment(data).then((response) => {
      commit(M_SET_BOOKING_INFO, response)
      dispatch(AUTH_LOAD_PROFILE, null, { root: true })
    })
  },

  async [A_CANCEL_APPOINTMENT]({ dispatch }, data) {
    return await APPOINTMENT.cancelAppointment(data).then((_) => {
      dispatch(AUTH_LOAD_PROFILE, null, { root: true })
    })
  },

  async [A_EDIT_APPOINTMENT]({ commit, dispatch }, data) {
    return await APPOINTMENT.editAppointment(data).then((response) => {
      commit(M_SET_BOOKING_INFO, response)
      dispatch(AUTH_LOAD_PROFILE, null, { root: true })
    })
  },

  async [A_FETCH_APPOINTMENT_DETAIL](_, data) {
    console.log('DATA', data)
    return await APPOINTMENT.getAppointment(data)
  }
}

// Mutations
const mutations = {
  updateField,
  [M_SET_UPCOMING_APPOINTMENT_LIST](state, appointments) {
    state.upcomingAppointments = appointments.map((appointment) => {
      appointment.type = AppointmentType.UPCOMING
      return appointment
    })
  },
  [M_SET_PAST_APPOINTMENT_LIST](state, appointments) {
    state.pastAppointments = appointments.map((appointment) => {
      appointment.type = AppointmentType.PAST
      return appointment
    })
  },
  [M_SET_AVAILABLE_DATES](state, dates) {
    state.availableDates = dates
  },
  [M_SET_AVAILABLE_SERVICES](state, services) {
    state.availableServices = services
  },
  [M_SET_AVAILABLE_TIMESLOTS](state, timeSlots) {
    state.availableTimeSlots = timeSlots
  },
  [M_SET_AVAILABLE_STYLISTS](state, stylists) {
    state.availableStylists = stylists
  },
  [M_SET_BOOKING_INFO](state, bookingInfo) {
    state.appointmentForm = defaultAppointmentForm
    state.bookingInfo = bookingInfo
  },
  [M_SET_APPOINTMENT_FORM](state, appointmentForm) {
    state.appointmentForm = appointmentForm
  },
  [M_RESET_APPOINTMENT_FORM](state) {
    state.appointmentForm = defaultAppointmentForm
    state.appointmentForm.appointmentSalon = undefined
    state.appointmentForm.appointmentDate = undefined
  },
  [M_SET_APPOINTMENT_FORM_SALON](state) {
    state.appointmentForm.appointmentDate = uiHelper.getTodayDate()
    state.appointmentForm.appointmentTimeSlots = undefined
    state.appointmentForm.appointmentServices = undefined
    state.appointmentForm.appointmentStylist = undefined
    state.appointmentForm.appointmentRemarks = ''
  },
  [M_SET_APPOINTMENT_FORM_STYLIST](state) {
    state.appointmentForm.appointmentDate = uiHelper.getTodayDate()
    state.appointmentForm.appointmentTimeSlots = undefined
    state.appointmentForm.appointmentServices = undefined
    state.appointmentForm.appointmentRemarks = ''
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
